import AIWorkerUrl from "./ai.worker.ts?worker&url"
import { PeerConnection, type Remote } from "@/utils/peer"
import type { AIWorker } from "./ai.worker"

import { AuxiliaryAIRawLoaderConnection } from "@/lib/raw/raw-loader-connection"
import { CatalogConnection } from "../catalog/catalog-connection"
import { isDeviceCompatible } from "@/utils/browser-compatibility"

export const AIConnection: PeerConnection<AIWorker> = isDeviceCompatible
	? new PeerConnection<AIWorker>(AIWorkerUrl, {
			label: "AI Editor",
			dependencies: {
				"raw-loader": AuxiliaryAIRawLoaderConnection,
				catalog: CatalogConnection,
			},
		})
	: ({
			proxy: undefined,
			connect() {
				return Promise.resolve(noopMethods() as Remote<AIWorker>)
			},
		} as unknown as PeerConnection<AIWorker>)

function noopMethods(): unknown {
	return new Proxy(
		{},
		{
			get: (_target, prop) => {
				if (prop === "then") {
					return undefined
				}
				return () => Promise.resolve(noopMethods())
			},
		},
	)
}
